export enum InitPageType {
  initForm = 1,
  loadApplication = 2
}
